import { Component, OnInit, ViewChild } from '@angular/core';
import { ParametroService } from '../services/parametro.service';
import { ParametroViewModel } from '../models/viewmodels/parametroViewModel';
import { FormControl } from '@angular/forms';
import { DoubleBounceComponent } from '../shared/spinners/double-bounce/double-bounce.component'
import { CustomAlertComponent } from '../shared/custom-alert/custom-alert.component';
import { Router } from '@angular/router'



@Component({
  selector: 'app-parametros',
  templateUrl: './parametros.component.html',  
  styleUrls: ['./parametros.component.scss']
})
export class ParametrosComponent implements OnInit {

  isLoading = true;
  display: boolean = false;

  parametros: Array<ParametroViewModel> = [];

  alert: any = {
    tipo: "success",
    titulo: "",
    mensaje: "",
    visible: false
  };

  errores = new Array();

  @ViewChild(DoubleBounceComponent)
  spinner: DoubleBounceComponent;

  @ViewChild(CustomAlertComponent)
  private alertComponent: CustomAlertComponent;

  constructor(private parametroService: ParametroService, private router: Router) { }

  ngOnInit() {
    this.obtenerParametros();
  }

  onSubmit(){
    this.spinner.isRunning = true;
    this.alert.visible = false;
    this.parametroService.actualizar(this.parametros)
      .map(result => {
        this.alert.visible = true;
        this.alert.titulo = "Actualizar parametros";
        if (result.status == 204) {
          this.alert.tipo = "success"
          this.alert.mensaje = "Los datos se han actualizado correctamente"
        } else {
          this.alert.tipo = "danger"
          this.alert.mensaje = "Los datos no se han podido actualizar. Por favor vuelva a intentarlo."
        }        
        this.alertComponent.setType(this.alert.tipo);
        this.spinner.isRunning = false;
      })
      .subscribe(data => {

      }, error => {
        var json = error.json();        
        this.spinner.isRunning = false;
        this.alert.visible = true;
        this.alert.titulo = "Actualizar parametros";
        this.alert.mensaje = "Los datos se han actualizado correctamente"
        this.alert.tipo = "danger"
        this.alertComponent.setType(this.alert.tipo);
        this.alert.mensaje = "Los datos no se han podido actualizar. Por favor vuelva a intentarlo."        
        if (json.modelState) {
          for (var key in json.modelState) {
            if (json.modelState[key].length == 1) {
              this.errores.push(json.modelState[key]);
            } else {
              for (var i = 0; i < json.modelState[key].length; i++) {
                this.errores.push(json.modelState[key][i]);
              }
            }
          }
        }
      });
  }

  obtenerParametros() {

    this.spinner.isRunning = true;
    this.parametroService.listado().subscribe(result => {
      this.spinner.isRunning = false;
      this.parametros = result;      
    });

  }

  

  getInputType(parametro: ParametroViewModel) {
    var tipo = "text";
    switch (parametro.tipoDato) {
      case 0:
        tipo = "text";
        break;
      case 1:
      case 2:
        tipo = "number";
        break;
      case 5:
        tipo = "password";
        break;
    }

    return tipo;
  }

  volver(){
    this.router.navigate(['dashboard/clientes']);
  }
}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/parametros/parametros.component.ts